if (!customElements.get('fcod-slideshow')) {
  customElements.define('fcod-slideshow', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video) return;
      this.cleanup?.();
      const events = new AbortController();
      const options = { signal: events.signal };
      let started = false;
      let pending = false;
      video.defaultMuted = true;
      video.muted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      const start = () => {
        if (started || pending || !this.isConnected || document.hidden) return;
        pending = true;
        const result = video.play();
        if (result) result.catch(() => {
          // Keep native controls usable when browser policy blocks autoplay.
          video.controls = true;
        }).finally(() => { pending = false; });
        else pending = false;
      };
      video.addEventListener('playing', () => { started = true; }, options);
      video.addEventListener('loadeddata', start, options);
      video.addEventListener('canplay', start, options);
      document.addEventListener('visibilitychange', start, options);
      document.addEventListener('pointerdown', start, options);
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) start();
        });
        observer.observe(video);
      }
      this.cleanup = () => { events.abort(); observer?.disconnect(); };
      start();
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
